module.exports = __webpack_public_path__ + "static/media/320x100_0015_en.fa050022.jpg";